export default __webpack_public_path__ + "static/media/i2pinitiator.ca8eb8f6.csv";